<template>
  <div class="CenterModule">
    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="getLoadingPreview"
    ></v-progress-linear>
    <v-row v-if="getStreamLive">
      <v-col cols="12" sm="12" md="6" class="pr-1">
        <LiveWidgetStream
          v-if="
            getSettings.enableLive &&
            getEventsDetail.length == 0 &&
            getPreview.length == 0
          "
        ></LiveWidgetStream>
      </v-col>
      <v-col cols="12" sm="12" md="6" class="pl-0 content-stream-embed">
        <LiveStream></LiveStream>
      </v-col>
    </v-row>

    <toolbar-top-agency></toolbar-top-agency>

    <template v-if="getEnableMobileBottomToolbar === true">
      <toolbar-top></toolbar-top>
    </template>

    <ToolbarSportsTree
      class="mt-3"
      v-if="getGameConsole === 'marketview' && getUseExternalTree === true"
      :gameMode="getLiveMode"
    ></ToolbarSportsTree>

    <Top-carousel
      v-if="getPreview.length === 0 && getEventsDetail.length === 0"
    ></Top-carousel>

    <FeaturedTournamentsWidget
      v-if="
        getFeaturedTournamentWidget === true &&
        getPreview.length === 0 &&
        getEventsDetail.length === 0
      "
    ></FeaturedTournamentsWidget>

    <NextEventsWidget
      v-if="
        getGameConsole === 'marketview' &&
        getPreview.length === 0 &&
        getEventsDetail.length === 0
      "
      key="next_event_preview"
      :limitEvent="5"
      :page="1"
      :closable="false"
      :controlPagination="true"
    ></NextEventsWidget>

    <LiveDetail
      v-if="
        getEventsLiveDetail.length > 0 &&
        this.getLiveMode == 'detail' &&
        getSettings.enableLive
      "
    ></LiveDetail>

    <LiveWidget
      v-if="
        getSettings.enableLive &&
        getEventsDetail.length == 0 &&
        getPreview.length == 0 &&
        this.getCountLive.length >= 10
      "
    ></LiveWidget>

    <Detail></Detail>

    <Preview v-if="getEventsDetail.length == 0"></Preview>

    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="getLoadingGeneral"
    ></v-progress-linear>
    <EventsBestPlayedWidget
      v-if="getPreview.length === 0 && getEventsDetail.length === 0"
    ></EventsBestPlayedWidget>
    <EventsDayWidgetServer v-if="getEventDay"></EventsDayWidgetServer>

    <NextEventsWidget
      key="next_event_widget"
      v-if="getGameConsole === 'default' && getNextEvent"
    ></NextEventsWidget>

    <v-snackbar v-model="getSnackbar">
      {{ $t(getSnackbarText) }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red darken-2"
          dark
          text
          v-bind="attrs"
          @click="closeSnackbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <Legend></Legend>
  </div>
</template>

<script>
import QuickBet from '@/components/center_widgets/QuickBetDetail'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import { mapActions, mapGetters } from 'vuex'
import Legend from './center_widgets/Legend'
import ToolbarTop from './generic/ToolbarTop'
import ToolbarTopAgency from './generic/ToolbarTopAgency'
import findLodash from 'lodash/find'

const LiveDetail = () => ({
  component: import('@/components/center_widgets/LiveDetail'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const PrintOdds = () => ({
  component: import('@/components/center_widgets/PrintOdds'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LiveWidget = () => ({
  component: import('@/components/center_widgets/LiveWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LiveWidgetStream = () => ({
  component: import('@/components/center_widgets/LiveWidgetStream'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LivePreview = () => ({
  component: import('@/components/center_widgets/LivePreview'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const Preview = () => ({
  component: import('@/components/center_widgets/Preview'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const FeaturedTournamentsWidget = () => ({
  component: import('@/components/center_widgets/FeaturedTournamentsWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const Detail = () => ({
  component: import('@/components/center_widgets/Detail'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const ImagesWidget = () => ({
  component: import('@/components/center_widgets/ImagesWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const ImagesSlider = () => ({
  component: import('@/components/center_widgets/ImagesSlider'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const TopCarousel = () => ({
  component: import('@/components/center_widgets/TopCarousel'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const EventsDayWidgetServer = () => ({
  component: import('@/components/center_widgets/EventsDayWidgetServer'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const EventsDayWidget = () => ({
  component: import('@/components/center_widgets/EventsDayWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LiveHomeWidget = () => ({
  component: import('@/components/center_widgets/LiveHomeWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const NextEventsWidget = () => ({
  component: import('@/components/center_widgets/NextEventsWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const EventsBestPlayedWidget = () => ({
  component: import('@/components/center_widgets/EventsBestPlayedWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LiveStream = () => ({
  component: import('@/components/center_widgets/LiveStream'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const ToolbarSportsTree = () => ({
  component: import('@/components/center_widgets/ToolbarSportsTree'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'Center',
  components: {
    ToolbarTopAgency,
    FeaturedTournamentsWidget,
    LiveWidgetStream,
    Legend,
    TopCarousel,
    LiveHomeWidget,
    ImagesSlider,
    LiveDetail,
    Preview,
    Detail,
    LivePreview,
    LiveWidget,
    LiveStream,
    NextEventsWidget,
    EventsDayWidget,
    EventsBestPlayedWidget,
    ImagesWidget,
    QuickBet,
    PrintOdds,
    EventsDayWidgetServer,
    LoadingSkeleton,
    ToolbarTop,
    ToolbarSportsTree,
  },
  data: () => ({}),
  async mounted() {
    this.fetchSports({ language: this.getLanguage })
    this.loadTournamentWidget()
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      getPreview: 'odds/getPreview',
      getEventsDetail: 'odds/getEventsDetail',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getSnackbar: 'settings/getSnackbar',
      getSnackbarText: 'settings/getSnackbarText',
      getLoadingPreview: 'odds/getLoadingPreview',
      getLoadingGeneral: 'odds/getLoadingGeneral',
      getQbet: 'tree/getQbet',
      getPrint: 'tree/getPrint',
      getLiveMode: 'odds/getLiveMode',
      getCountLive: 'odds/getCountLive',
      getSettings: 'cart/getSettings',
      getEventDay: 'settings/getEventDay',
      getNextEvent: 'settings/getNextEvent',
      getLanguage: 'settings/getLanguage',
      getStreamLive: 'settings/getStreamLive',
      getNextEventModuleSelected: 'odds/getNextEventModuleSelected',
      getGameConsole: 'settings/getGameConsole',
      getEnableCentralBanner: 'settings/getEnableCentralBanner',
      getCountNextEvents: 'odds/getCountNextEvents',
      getFeaturedTournamentAutoLoad: 'settings/getFeaturedTournamentAutoLoad',
      getFeaturedTournamentWidget: 'settings/getFeaturedTournamentWidget',
      getEnableMobileBottomToolbar: 'settings/getEnableMobileBottomToolbar',
      getRulesSkin: 'rules/getRulesSkin',
      getUseExternalTree: 'uiConfig/useExternalTree',
    }),
  },
  methods: {
    ...mapActions({
      setSnackbar: 'settings/setSnackbar',
      fetchSports: 'sport/fetchSports',
      fetchFeaturedTournaments: 'settings/fetchFeaturedTournaments',
      setFeaturedTournamentsInfo: 'settings/setFeaturedTournamentsInfo',
      fetchPreview: 'odds/fetchPreview',
    }),
    closeSnackbar() {
      this.setSnackbar(false)
    },

    async loadTournamentWidget() {
      try {
        const response = await this.fetchFeaturedTournaments()
        if (!response || !response.data || !response.data.featuredTournaments)
          return

        const featuredTournaments = response.data.featuredTournaments
        const translationSkinRules = this.getRulesSkin.filter(
          el => el.type === 'translation'
        )

        if (
          Array.isArray(featuredTournaments) &&
          featuredTournaments.length > 0
        ) {
          for (const tournament of featuredTournaments) {
            const tournamentId = tournament.tournamentId.toString()
            const tournamentTranslations = translationSkinRules.find(
              el => el.source.toString() === tournamentId
            )

            if (tournamentTranslations && tournamentTranslations.detail) {
              const langTranslation = findLodash(
                tournamentTranslations.detail,
                { lang: this.getLanguage }
              )
              if (
                langTranslation &&
                langTranslation.text &&
                langTranslation.text !== ''
              ) {
                tournament.tournamentName = langTranslation.text
              }
            }
          }
        }

        await this.setFeaturedTournamentsInfo(featuredTournaments)
      } catch (error) {
        console.error('Error while loading tournament widget:', error)
      }
    },
  },
}
</script>
